var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackFridayBannerArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 63,
    viewBox: "0 0 38 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0223 55.5906C35.4979 56.6731 34.9922 57.7555 34.4771 58.8379C34.6457 48.6149 33.344 38.3457 22.2844 34.3398C15.8697 32.0176 6.95459 31.8696 3.0121 25.4212C0.717777 21.6651 1.58868 16.993 2.03818 12.9038C2.47832 8.9164 2.87163 4.91972 3.32113 0.923037C3.34923 0.645489 2.86227 0.580728 2.82481 0.858276C1.33584 11.7381 -3.89897 25.9301 8.90243 31.7123C15.0924 34.5063 22.8744 34.312 27.9781 39.2338C33.0818 44.1557 33.2972 52.001 32.9694 58.7177C31.7988 57.7278 30.7126 56.6731 29.6637 55.5259C28.9614 54.7487 27.8657 55.8774 28.5212 56.6546C30.1226 58.5882 31.7333 60.5217 33.344 62.4461C33.6624 62.8254 34.4209 62.7236 34.6269 62.2795C35.5634 60.3182 36.4999 58.3569 37.4176 56.3863C37.8484 55.4611 36.4718 54.647 36.0223 55.5814V55.5906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFridayBannerArrow);
export default __webpack_public_path__ + "static/media/black-friday-banner-arrow.a90330c3ed074893fb09639506c4af5b.svg";
export { ForwardRef as ReactComponent };